// extracted by mini-css-extract-plugin
export var contact = "Contact-module--contact--34cd8";
export var container = "Contact-module--container--0fe08";
export var content = "Contact-module--content--b58cc";
export var copy = "Contact-module--copy--fdfb5";
export var eyebrow = "Contact-module--eyebrow--41051";
export var form = "Contact-module--form--6affa";